import { createContext, useContext, useEffect, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";
import { useSearchParams } from "react-router-dom";
import { COLORS } from "../../ui/Theme";

export const TicketContext = createContext();

const TicketProvider = ({ children }) => {
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [searchParams] = useSearchParams();

  const { data: tickets, isLoading } = useSWR("/support/ticket", fetchData, {
    dedupingInterval: 60000,
  });

  const query = searchParams.get("query");
  const filter = searchParams.get("filter");

  useEffect(() => {
    if (!tickets) return;

    let filteredItems = tickets;

    if (query) {
      filteredItems = filteredItems.filter((ticket) =>
        ticket.title.toLowerCase().includes(query.toLowerCase())
      );
    }

    if (filter) {
      filteredItems = filteredItems.filter(
        (ticket) => ticket.status === filter
      );
    }

    setFilteredTickets(filteredItems);
  }, [query, filter, tickets]);

  // translate to farsi and customization style
  const statusDetails = {
    open: { text: "باز", color: COLORS.BLUE, bg: COLORS.SOFTBLUE },
    pending: {
      text: "در حال بررسی",
      color: COLORS.ORANGE,
      bg: COLORS.SOFTORANGE,
    },
    answered: {
      text: "پاسخ داده شده",
      color: COLORS.GREEN,
      bg: COLORS.SOFTGREEN,
    },
    closed: { text: "بسته شده", color: COLORS.RED, bg: COLORS.SOFTRED },
  };

  return (
    <TicketContext.Provider
      value={{
        tickets,
        filteredTickets,
        statusDetails,
        isLoading,
      }}
    >
      {children}
    </TicketContext.Provider>
  );
};

export default TicketProvider;

export const useTicketContext = () => useContext(TicketContext);
